import { IPagination } from 'app/types/common';

export interface IConnectionRunsState {
  readonly connectionRunsById?: any;
  readonly connectionRunIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectConnectionRunLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddConnectionRun?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationConnectionRunIds?: string[];
  readonly currentConnectionRunId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IConnectionRunsSelector
  extends IConnectionRunsState {
  readonly currentConnectionRun?: any;
  readonly currentFormConnectionRun?: any;
  readonly connectionRunsFilteredByOrganisationInSelectFormat?: any;
  readonly connectionRunsByTagAndIdInSelectFormat?: any;
  readonly connectionRunsByIdInSelectFormat?: any;
  readonly connectionRunsFilteredByCompetitionInSelectFormat?: any;
  readonly connectionRunsFilteredByIdInSelectFormat?: any;
}

export enum ConnectionRunsActionTypes {
  GET_ALL_CONNECTION_RUNS_REQUESTED = 'redux-app/connection-runs/GET_ALL_CONNECTION_RUNS_REQUESTED',
  GET_ALL_CONNECTION_RUNS_PENDING = 'redux-app/connection-runs/GET_ALL_CONNECTION_RUNS_PENDING',
  GET_ALL_CONNECTION_RUNS_SUCCESS = 'redux-app/connection-runs/GET_ALL_CONNECTION_RUNS_SUCCESS',
  GET_ALL_CONNECTION_RUNS_FAIL = 'redux-app/connection-runs/GET_ALL_CONNECTION_RUNS_FAIL',
  GET_CONNECTION_RUN_REQUESTED = 'redux-app/connection-runs/GET_CONNECTION_RUN_REQUESTED',
  GET_CONNECTION_RUN_PENDING = 'redux-app/connection-runs/GET_CONNECTION_RUN_PENDING',
  GET_CONNECTION_RUN_SUCCESS = 'redux-app/connection-runs/GET_CONNECTION_RUN_SUCCESS',
  GET_CONNECTION_RUN_FAIL = 'redux-app/connection-runs/GET_CONNECTION_RUN_FAIL',
  UPDATE_CONNECTION_RUN_REQUESTED = 'redux-app/connection-runs/UPDATE_CONNECTION_RUN_REQUESTED',
  UPDATE_CONNECTION_RUN_PENDING = 'redux-app/connection-runs/UPDATE_CONNECTION_RUN_PENDING',
  UPDATE_CONNECTION_RUN_SUCCESS = 'redux-app/connection-runs/UPDATE_CONNECTION_RUN_SUCCESS',
  UPDATE_CONNECTION_RUN_FAIL = 'redux-app/connection-runs/UPDATE_CONNECTION_RUN_FAIL',
  CREATE_CONNECTION_RUN_REQUESTED = 'redux-app/connection-runs/CREATE_CONNECTION_RUN_REQUESTED',
  CREATE_CONNECTION_RUN_PENDING = 'redux-app/connection-runs/CREATE_CONNECTION_RUN_PENDING',
  CREATE_CONNECTION_RUN_SUCCESS = 'redux-app/connection-runs/CREATE_CONNECTION_RUN_SUCCESS',
  CREATE_CONNECTION_RUN_FAIL = 'redux-app/connection-runs/CREATE_CONNECTION_RUN_FAIL',
  DELETE_CONNECTION_RUN_REQUESTED = 'redux-app/connection-runs/DELETE_CONNECTION_RUN_REQUESTED',
  DELETE_CONNECTION_RUN_PENDING = 'redux-app/connection-runs/DELETE_CONNECTION_RUN_PENDING',
  DELETE_CONNECTION_RUN_SUCCESS = 'redux-app/connection-runs/DELETE_CONNECTION_RUN_SUCCESS',
  DELETE_CONNECTION_RUN_FAIL = 'redux-app/connection-runs/DELETE_CONNECTION_RUN_FAIL',
  SELECT_CONNECTION_RUN_REQUESTED = 'redux-app/connection-runs/SELECT_CONNECTION_RUN_REQUESTED',
}

export default null;
